import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";

// Create the context
const AuthContext = createContext();

// Auth Provider Component
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [role, setRole] = useState(null);
  console.log(token);

  useEffect(() => {
    if (user) {
      // Extract roles when user state changes
      setRole(user.roles);
    } else {
      setRole(null);
    }
  }, [user]);
  

  // Load user from localStorage on first load
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const storedToken = localStorage.getItem("token");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
      setToken(storedToken);
    }
  }, []);
  // Sync across browser tabs (optional but useful)
  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "user") {
        const updatedUser = event.newValue ? JSON.parse(event.newValue) : null;
        setUser(updatedUser);
      }
      // Handle global logout (any tab)
      if (event.key === "logout") {
        setUser(null);
        localStorage.removeItem("user");
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);
  //  After token Expries Logout automatically
  useEffect(() => {
    if (!token || !user) return;

    const expiresIn = parseInt(localStorage.getItem("expiresIn"), 10);
    const loginTime = parseInt(localStorage.getItem("loginTime"), 10);
    const timeElapsed = Date.now() - loginTime;
    if (timeElapsed >= expiresIn) {
      toast.warning("Token has expired. You are being logging out.");
      // Delay logout by 1-2 seconds to allow toast to show
      setTimeout(() => {
        logout();
      }, 2000);
    } else {
      // Auto logout when token expires
      const timeout = setTimeout(() => {
        toast.warning("Token has expired. You are being logging out.");
        setTimeout(() => {
          logout();
        }, 2000);
      }, expiresIn - timeElapsed);
      return () => clearTimeout(timeout);
    }
  }, [token, user]);
  // Optional: log out
  const logout = () => {
    setTimeout(() => {
      localStorage.removeItem("user");
      localStorage.setItem("logout", Date.now().toString());
      localStorage.removeItem("bookFilters");
      localStorage.clear();
      setTimeout(() => localStorage.removeItem("logout"), 500);
      setUser(null);
      setToken(null);
    }, 1000);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, logout, role }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook for easy access
export const useAuth = () => useContext(AuthContext);
